import BaseAPI from './base/base-api';

class UserAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'user';
}

export default new UserAPI();
